module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isOnline) ? _c('div', {
    staticClass: "layout"
  }, [_c('top-menu'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1)], 1)], 1) : _c('offline')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e6fb320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/layout.vue
// module id = 283
// module chunks = 1